const identity = (value) => value ?? "";

export const Header = ({
  t = identity,
  eyebrow = "",
  title = "",
  description = "",
}) => {
  const translate = typeof t === "function" ? t : identity;

  return (
    <div className="border-b border-white/5">
      {eyebrow && (
        <div className="mb-2">
          <p className="text-[11px] font-mono uppercase tracking-[0.4em] text-gray-200 flex items-center gap-2">
            {translate(eyebrow)}
          </p>
        </div>
      )}
      {title && (
        <div className="flex items-center gap-3 mb-2">
          <h1 className="text-4xl font-black uppercase tracking-tight text-white">
            {translate(title)}
          </h1>
        </div>
      )}
      {description && (
        <p className="text-base text-gray-200 font-mono tracking-widest uppercase">
          {translate(description)}
        </p>
      )}
    </div>
  );
};
